<script setup>
import { RouterView } from "vue-router";
import SectionHeader from "../components/texts/SectionHeader.vue";
import BaseView from "./BaseView.vue";
import { COPY_QUOTE_PATH, TEST_DT_LOGIN_PATH } from "../const/route";
</script>

<template>
    <BaseView>
        <div class="text-center">
            <SectionHeader
                label="REACH Dev Utilities"
                :show-divider="false"
                :center="true"
            />
            <nav class="flex justify-center">
                <RouterLink :to="COPY_QUOTE_PATH"
                    >Copy Prod Sputnik quote</RouterLink
                >
                <RouterLink :to="TEST_DT_LOGIN_PATH"
                    >Test DT login token</RouterLink
                >
            </nav>
        </div>

        <RouterView />
    </BaseView>
</template>

<style scoped>
header {
    line-height: 1.5;
    max-height: 100vh;
}

nav {
    width: 100%;
    font-size: 12px;
    text-align: center;
    margin-top: 2rem;
}

nav a.router-link-exact-active {
    color: var(--color-text);
}

nav a.router-link-exact-active:hover {
    background-color: transparent;
}

nav a {
    display: inline-block;
    padding: 0 1rem;
    border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
    border: 0;
}

@media (min-width: 1024px) {
    header {
        display: flex;
        place-items: center;
        padding-right: calc(var(--section-gap) / 2);
    }

    header .wrapper {
        display: flex;
        place-items: flex-start;
        flex-wrap: wrap;
    }

    nav {
        text-align: left;
        margin-left: -1rem;
        font-size: 1rem;

        padding: 1rem 0;
        margin-top: 1rem;
    }
}
</style>
